<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.states')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MaterialStateForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MaterialStateForm from '../../components/materialstate/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'MaterialState';

const { mapFields } = createHelpers({
  getterType: 'materialstate/getField',
  mutationType: 'materialstate/updateField'
});

export default {
  name: 'MaterialStateCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialStateForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('materialstate', ['create', 'reset'])
  }
};
</script>
